import { ApiUrl } from '@common/enums';
import { TicketValidationParams, TicketValidationResponse } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';

const ticketValidationService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchTicket: builder.query<TicketValidationResponse, TicketValidationParams>({
            query: ({ ...params }) => ({
                url: ApiUrl.VALIDATE_TICKET,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useLazyFetchTicketQuery } = ticketValidationService;
